export default function validateBatchCreatorsUrls(urls: string[]) {
	for (let url of urls) {
		url = url.trim();

		if (
			['youtube.com/', 'tiktok.com/', 'instagram.com/'].every(
				(domain) => !url?.includes(domain),
			)
		) {
			return Promise.reject(
				new Error(`Invalid URL: ${url ? url : '(empty line)'}`),
			);
		}

		const err = new Error(`Invalid URL: ${url ? url : '(empty line)'}`);

		if (
			url?.includes('youtube.com/') &&
			!url.match(
				/^https:\/\/(www\.)?youtube\.com\/(watch\?v=[\w-]+|shorts\/[\w-]+)$/i,
			)
		) {
			return Promise.reject(err);
		} else if (
			url?.includes('tiktok.com/') &&
			!url.match(/^https:\/\/(www\.)?tiktok\.com\/@[\w\.\-]+\/video\/\d+\/?$/i)
		) {
			return Promise.reject(err);
		} else if (
			url?.includes('instagram.com/') &&
			!url.match(/^https:\/\/(www\.)?instagram\.com\/reel\/[\w-]+\/?$/i)
		) {
			return Promise.reject(err);
		}
	}

	return Promise.resolve();
}
